import React from "react";
import { Flex, FlexProps } from "antd";
import styled, { css } from "styled-components";
import { useAppToken } from "../../theme/v6/useAppToken";
import { useThemeMode } from "../../theme/ThemeModeProvider";

type Props = FlexProps & {
  $disabled?: boolean;
  $error?: boolean;
  $padding?: number;
};

const Wrapper = styled(Flex)<{ $background?: string; $disabled?: boolean }>`
  height: 100%;
  transition: background-color 0.2s ease;

  ${(props) =>
    props.$background &&
    css`
      background: ${props.$background};
    `}

  ${(props) =>
    props.$disabled &&
    css`
      cursor: no-drop;
    `}
`;

const TablesCellWrapper = React.forwardRef<HTMLDivElement, Props>(function TablesCellWrapper(
  { $disabled, $error, $padding = 6, style, ...props },
  ref,
) {
  const { token } = useAppToken();
  const { themeMode } = useThemeMode();
  const disabledBackground = themeMode === "dark" ? token.colorFillTertiary : token.appGray2;
  const errorBackground = themeMode === "dark" ? token.red2 : token.red1;
  return (
    <Wrapper
      {...props}
      ref={ref}
      style={{ display: "flex", boxSizing: "border-box", padding: $padding, ...style }}
      $disabled={$disabled}
      $background={$error ? errorBackground : $disabled ? disabledBackground : undefined}
    />
  );
});

export default TablesCellWrapper;
